// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selector_NOtwB {
  width: 100%;
  background-color: white !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/actions/locations/SetConfigurationDialog.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kCAAkC;AACpC","sourcesContent":[".selector {\n  width: 100%;\n  background-color: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selector": `selector_NOtwB`
};
export default ___CSS_LOADER_EXPORT___;
